import React from 'react'
import './styles/Footer.css'

const Footer = () => {
  return (
    <footer>
      <h4>
        DESIGNED & DEVELOPED BY <span>MANISH</span>
      </h4>
    </footer>
  )
}

export default Footer
